<template>
  <div class="col-lg-12 w-100">
    <div class="card flex-fill mb-3">
      <div class="pro-head">
        <h4 class="pro-titles mb-0">Language</h4>
      </div>
      <div class="pro-body">
        <div
          class="form-row align-items-center skill-cont"
          v-for="item in event"
          :key="item.id"
        >
          <div class="input-block col-md-6">
            <label class="form-label">Language</label>
            <input type="text" class="form-control" />
          </div>
          <div class="input-block col-md-5">
            <label class="form-label">Language Fluency</label>
            <vue-select :options="LanguageFluencyThree" placehloder="Select" />
          </div>
          <div class="input-block col-md-1 mb-0">
            <a
              href="javascript:void(0);"
              class="btn trash-icon"
              @click="deleteEvent(event)"
              ><i class="far fa-trash-alt"></i
            ></a>
          </div>
        </div>
        <div class="form-row align-items-center skill-cont">
          <div class="input-block col-md-6">
            <label class="form-label">Language</label>
            <input type="text" class="form-control" />
          </div>
          <div class="input-block col-md-5">
            <label class="form-label">Language Fluency</label>
            <vue-select :options="LanguageFluencyThree" placehloder="Select" />
          </div>
          <div class="input-block col-md-1 mb-0">
            <a
              href="javascript:void(0)"
              class="btn fund-btn lang-add add-btn-profile mb-0"
              @click="add()"
              ><i class="feather-plus"></i
            ></a>
          </div>
          <div id="lang_add_row" class="w-100"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const event = [
  {
    id: 1,
    placeholder: "Select",
    value: "Front End Developer",
  },
  {
    id: 2,
    placeholder: "Select",
    value: "UI UX Designer",
  },
  {
    id: 4,
    placeholder: "Select",
    value: "React Developer",
  },
];
export default {
  data() {
    return {
      LanguageFluency: ["Select", "Intermediate", "Expert"],
      LanguageFluencyOne: ["Select", "Intermediate", "Expert"],
      LanguageFluencyTwo: ["Select", "Intermediate", "Expert"],
      LanguageFluencyThree: ["Select", "Intermediate", "Expert"],
      event,
    };
  },
  methods: {
    deleteEvent: function (event) {
      this.event.splice(this.event.indexOf(event), 1);
    },
    add() {
      this.event.push({
        id: 5,
        placeholder: "Intermediate",
        value: "React Developer",
      });
    },
  },
};
</script>
